import AdminReportingNewTemplate from './container';

export default AdminReportingNewTemplate;
